/**
 * 이미지 디스플레이용 로깅 유틸리티
 * 개발 환경에서만 로그를 출력하는 함수를 제공
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var resolveIsDevelopment = function() {
    var _globalProcess_env;
    var globalProcess = globalThis.process;
    var nodeEnv = globalProcess === null || globalProcess === void 0 ? void 0 : (_globalProcess_env = globalProcess.env) === null || _globalProcess_env === void 0 ? void 0 : _globalProcess_env.NODE_ENV;
    if (typeof nodeEnv === 'string') {
        return nodeEnv === 'development';
    }
    try {
        var viteEnv = import.meta.env;
        if (typeof (viteEnv === null || viteEnv === void 0 ? void 0 : viteEnv.DEV) === 'boolean') {
            return viteEnv.DEV;
        }
        if (typeof (viteEnv === null || viteEnv === void 0 ? void 0 : viteEnv.MODE) === 'string') {
            return viteEnv.MODE === 'development';
        }
    } catch (e) {
    // ignore environments without import.meta (e.g. Node tests)
    }
    return false;
};
/**
 * 로거 생성 함수
 * 
 * @param options 로깅 옵션
 * @returns 로깅 함수
 */ export var createLogger = function(options) {
    var _ref = options || {}, _ref_prefix = _ref.prefix, prefix = _ref_prefix === void 0 ? '[ImageDisplay]' : _ref_prefix, _ref_enabled = _ref.enabled, enabled = _ref_enabled === void 0 ? resolveIsDevelopment() : _ref_enabled, _ref_level = _ref.level, level = _ref_level === void 0 ? 'debug' : _ref_level;
    /**
     * 메시지 로깅 함수
     * 
     * @param message 로그 메시지
     * @param args 추가 인자
     */ return function(message) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        if (!enabled) {
            return;
        }
        var formattedMessage = "".concat(prefix, " ").concat(message);
        switch(level){
            case 'error':
                var _console;
                (_console = console).error.apply(_console, [
                    formattedMessage
                ].concat(_to_consumable_array(args)));
                break;
            case 'warn':
                var _console1;
                (_console1 = console).warn.apply(_console1, [
                    formattedMessage
                ].concat(_to_consumable_array(args)));
                break;
            case 'info':
                var _console2;
                (_console2 = console).info.apply(_console2, [
                    formattedMessage
                ].concat(_to_consumable_array(args)));
                break;
            case 'debug':
            default:
                var _console3;
                (_console3 = console).log.apply(_console3, [
                    formattedMessage
                ].concat(_to_consumable_array(args)));
                break;
        }
    };
};
